document.addEventListener('DOMContentLoaded', function() {

  const background = document.querySelectorAll('.parallax-background');

  // Helper to get element's offset from top of document
  function getOffsetTop(elem) {
    let offsetTop = 0;
    while (elem) {
      offsetTop += elem.offsetTop;
      elem = elem.offsetParent;
    }
    return offsetTop;
  }

  // For each element with the class "parallax-background", set the background position relative to its offset from the document
  const parallax = () => {
    const scrollY = window.scrollY || window.pageYOffset;
    background.forEach(bg => {
      const elemOffsetTop = getOffsetTop(bg);
      const speed = 0.15; // Adjust this value to control the parallax speed
      const offset = (scrollY - elemOffsetTop) * speed;
      bg.style.setProperty('--parallax-bg-y', `${offset}px`);
    });
  }

  window.addEventListener('scroll', parallax);
  window.addEventListener('resize', parallax);
  parallax(); // Run once on load so background is positioned correctly
});
